export default class Users {

  id = null;
  username = "";
  password = "";
  name = "";
  email = "";
  phone = "";

  bookHierarchy = null;
  displayRoles = [];
  language = null;

  active = false;
  main = false;
  mailNotification = true;
  mailConfirmation = false;
  hideWarning = false;
  customer = null;
  registrationPending = false;

  firstLogin = null;
  lastLogin = null;

  constructor() {
  }
}